import { GetterTree } from 'vuex';
import {DetailInfo, ProfileState, Transaction} from './types';
import { RootState } from '@/store/types';
import { USER_TRANSACTIONS, USER_INFO } from '@/modules/profile/store/constants';

const getters: GetterTree<ProfileState, RootState> = {
    [USER_TRANSACTIONS](state: ProfileState): Transaction[] | undefined {
        return state.transactions.list;
    },
    [USER_INFO](state: ProfileState): DetailInfo | undefined {
        return state.info.details;
    },
};

export default getters;
